import { Head } from '@inertiajs/react';
import { Card, CardContent } from '@/components/ui/card';
import type { AdminFeedbacksIndex } from '@/types';
import { FeedbackMetricsPanel } from './components/FeedbackMetricsPanel';
import { FeedbackSearch } from './components/FeedbackSearch';
import { FeedbackTable } from './components/FeedbackTable';

export default function Index({
  feedback,
  metrics,
  pagination,
  filters,
  eventSlug,
  eventName,
  title,
}: AdminFeedbacksIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto space-y-6 py-8">
        <div>
          <h1 className="font-bold text-3xl tracking-tight">Hacker Feedback</h1>
          <p className="text-muted-foreground">
            Browse hacker feedback responses for {eventName}
          </p>
        </div>

        <FeedbackMetricsPanel metrics={metrics} />

        <FeedbackSearch eventSlug={eventSlug} initialParams={filters} />

        <Card>
          <CardContent className="p-0">
            <FeedbackTable
              eventSlug={eventSlug}
              feedback={feedback}
              pagination={pagination}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
